import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  CognitoAiStats,
  CognitoAiDataGrid,
  CognitoAiUploadTile,
} from "../components/cognito-ai";

const CognitoAiFragment = () => {
  return (
    <div className="fragmentContainer">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={12} md={10}>
                  <CognitoAiStats />
                </Grid>
                <CognitoAiUploadTile />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={12}>
          <Card>
            <CardHeader title="Cognito AI Uploads"></CardHeader>
            <CardContent sx={{ padding: 0 }}>
              <CognitoAiDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default CognitoAiFragment;
